module.exports = __webpack_public_path__ + "static/media/checkBoxFalse.5ecb567e.svg";